module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-breeds-c66769437fc83b82afe375940c537ca7.svg";